module.exports = __webpack_public_path__ + "static/dinner_room_night_mobile-47224fe4cd205c9b65cdb242c9bd81ea.jpg";